import { api } from "./apiConfig";

export const getRankedAlternatives = async (data) => {
  try {
    const response = await api.post(
      "/Ranking/get-ranked-alternatives",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const uploadFile = async (data) => {
  try {
    const response = await api.post("/Ranking/upload-file", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

